import { useEffect } from "react";

import { CommandPaletteActiveActionSource } from "../types";

// Scrolls active item into view when activeActionId changes via keyboard
// Uses "center" alignment to ensure padding/spacing around items remains visible
const useCommandPaletteScrollToActive = (
  activeActionId: string | undefined,
  activeActionSource: CommandPaletteActiveActionSource | undefined
) => {
  useEffect(() => {
    if (activeActionSource !== "keyboard") return;

    const activeElement = document.querySelector('[data-active="true"]');
    if (activeElement) {
      activeElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [activeActionId, activeActionSource]);
};

export default useCommandPaletteScrollToActive;
